import { useEffect, useState } from 'react';
import api from '../lib/api';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { HelpCircle } from 'lucide-react';

export default function FAQPage() {
  const [faq, setFaq] = useState([]);
  useEffect(() => { api.get('/faq').then(r => setFaq(r.data)).catch(() => {}); }, []);

  const categories = [...new Set(faq.map(f => f.category))];

  return (
    <div className="min-h-screen py-24 md:py-32 bg-background" data-testid="faq-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-4">
            <HelpCircle className="w-8 h-8 text-primary" />
          </div>
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-3">Questions fréquentes</h1>
          <p className="text-muted-foreground text-lg">Retrouvez les réponses aux questions les plus courantes sur nos services.</p>
        </div>

        {categories.map(cat => (
          <div key={cat} className="mb-8">
            <h2 className="font-heading text-lg font-semibold text-foreground mb-3 capitalize">{cat}</h2>
            <Accordion type="single" collapsible className="space-y-2">
              {faq.filter(f => f.category === cat).map(item => (
                <AccordionItem key={item.id} value={item.id} className="bg-white rounded-xl border border-border/50 px-6 overflow-hidden">
                  <AccordionTrigger className="text-left font-body text-sm font-medium py-4 hover:no-underline">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-sm leading-relaxed pb-4">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </div>
    </div>
  );
}
